var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 24C7.37602 22.5638 5.87078 20.9893 4.49998 19.293C2.44285 16.7455 1.13613e-06 12.9516 1.13613e-06 9.33636C-0.00182221 5.56053 2.19116 2.15569 5.55563 0.710666C8.9201 -0.73436 12.7929 0.065257 15.3668 2.73639C17.0594 4.4835 18.0075 6.86005 18 9.33636C18 12.9516 15.5571 16.7455 13.4999 19.293C12.1291 20.9893 10.6239 22.5638 8.99996 24ZM8.99996 5.33718C7.62194 5.33718 6.3486 6.09942 5.65959 7.33677C4.97058 8.57412 4.97058 10.0986 5.65959 11.3359C6.3486 12.5733 7.62194 13.3355 8.99996 13.3355C11.1302 13.3355 12.8571 11.545 12.8571 9.33636C12.8571 7.12767 11.1302 5.33718 8.99996 5.33718Z",
    fill: "#1A79FF"
  })));
};
export { SvgLocation as ReactComponent };